export enum WayToPayEnums {
  anticipos = 0,
  efectivo = 1,
  cheque = 2,
  transferencia = 3
}